import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import { useSelector } from "react-redux";
import useFetchIntegratedExchanges from "../../../hooks/api/useFetchIntegratedExchanges";
import { Select } from "antd";
import { TbReportSearch } from "react-icons/tb";
import { FaChevronDown } from "react-icons/fa6";

function SelectExchangeSettings({ changeConfig, selectedExchange }) {
  const {
    exchangeState: { integratedData, integratedDataLoading },
  } = useSelector((state) => state);

  const exchangeList = [...integratedData]
    .filter((item) => item?.status === "Active")
    .sort((a, b) => (b?.id === "cryptocrispy" ? 1 : -1));

  const selectExchange = (id) => {
    changeConfig("selected_exchange", id?.toLowerCase());
  };

  useFetchIntegratedExchanges();

  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> Select the exchange you
          want to trade?
        </h6>
      </div>
      <Select
        placeholder={integratedDataLoading ? "Loading..." : "Choose Exchange"}
        value={
          selectedExchange === "cryptocrispy"
            ? "Demo Exchange"
            : selectedExchange || "Select an exchange"
        }
        onChange={selectExchange}
        // disabled={exchangesLoading || loading}
        disabled={integratedDataLoading}
        optionFilterProp="children"
        showSearch
        suffixIcon={<FaChevronDown color="black" />}
        filterOption={(input, option) =>
          (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
        }
        className={styles.exchangeMenu}
      >
        {exchangeList?.map((exchange) => (
          <Select.Option key={exchange?.id} value={exchange?.id}>
            {exchange?.name}
          </Select.Option>
        ))}
      </Select>
    </>
  );
}

export default SelectExchangeSettings;
